import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormInput from "../../components/common/FormInput/FormInput";
import { FaArrowLeftLong } from "react-icons/fa6";
import Button from "../../components/common/Button/Button";
import UploadImage from "../../components/common/UploadImage/UplaodImage";

const Home =()=>{
    return(
        <>
            <div className="d-flex align-items-center gap-3 mb-3">
                <div
                    className="d-flex align-items-center gap-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => window.history.back()}
                >
                    <FaArrowLeftLong />
                    <h3 className="mb-0 management-tile ml-2">Homepage Management</h3>
                </div>
            </div>

            <Row className="g-3">
                <Col xl={6} lg={6} sm={12}>
                    <label className="form-label">Banner Title</label>
                    <FormInput
                        placeholder="Banner Title"
                        // value={formData.category}
                        // onChange={(e) => handleChange("category", e.target.value)}
                    />
                </Col>

                <Col xl={6} lg={6} sm={12}>
                    <label className="form-label">Banner Title 2</label>
                    <FormInput
                        placeholder="Banner Title 2"
                        // value={formData.author}
                        // onChange={(e) => handleChange("author", e.target.value)}
                    />
                </Col>

                <Col xs={12}>
                    <label className="form-label">Banner Description</label>
                    <FormInput
                        placeholder="Banner description"
                        type="textarea"
                        // value={formData.description}
                        // onChange={(e) => handleChange("description", e.target.value)}
                    />
                </Col>

                <Col xl={6} lg={6} sm={12}>
                    <label className="form-label">Primary Feature Title</label>
                    <FormInput
                        placeholder="Industry Title"
                        // value={formData.title}
                        // onChange={(e) => handleChange("title", e.target.value)}
                    />
                </Col>

                <Col xl={6} lg={6} sm={12}>
                    <label className="form-label">Primary Feature Sub-Title</label>
                    <FormInput
                        placeholder="Industry Title"
                        // value={formData.title}
                        // onChange={(e) => handleChange("title", e.target.value)}
                    />
                </Col>

                <Col xl={6} lg={6} sm={12}>
                    <label className="form-label">Secondary Feature Title</label>
                    <FormInput
                        placeholder="Industry Title"
                        // value={formData.title}
                        // onChange={(e) => handleChange("title", e.target.value)}
                    />
                </Col>

                <Col xl={6} lg={6} sm={12}>
                    <label className="form-label">Secondary Feature Sub-Title</label>
                    <FormInput
                        placeholder="Industry Title"
                        // value={formData.title}
                        // onChange={(e) => handleChange("title", e.target.value)}
                    />
                </Col>
            </Row>

            <Row className="g-3">
                <Col xs={12} className="py-3">
                    <h3 className="Website-title">About Banner</h3>
                    <hr />
                </Col>

                <Col xl={6} lg={6} sm={12}>
                    <label className="form-label">About Us Title</label>
                    <FormInput
                        placeholder="Banner Title"
                        // value={formData.category}
                        // onChange={(e) => handleChange("category", e.target.value)}
                    />
                </Col>

                <Col xl={6} lg={6} sm={12}>
                    <label className="form-label">About Us Sub-Title</label>
                    <FormInput
                        placeholder="Banner Title 2"
                        // value={formData.author}
                        // onChange={(e) => handleChange("author", e.target.value)}
                    />
                </Col>

                <Col xs={12}>
                    <label className="form-label">About Description</label>
                    <FormInput
                        placeholder="Description"
                        type="textarea"
                        // value={formData.description}
                        // onChange={(e) => handleChange("description", e.target.value)}
                    />
                </Col>

                <Col xl={12} lg={12} md={12} sm={12}>
                    <label className="form-label">Upload About Banner</label>
                    <UploadImage />
                </Col>
            </Row>

            <Row className="g-3">
                <Col xs={12} className="py-3">
                    <h3 className="Website-title">Our Mission</h3>
                    <hr />
                </Col>

                <Col xl={12} lg={12} sm={12}>
                    <label className="form-label">Our Mission Title</label>
                    <FormInput
                        placeholder="Banner Title"
                        // value={formData.category}
                        // onChange={(e) => handleChange("category", e.target.value)}
                    />
                </Col>

                <Col xs={12}>
                    <label className="form-label">Our Mission Description</label>
                    <FormInput
                        placeholder="Description"
                        type="textarea"
                        // value={formData.description}
                        // onChange={(e) => handleChange("description", e.target.value)}
                    />
                </Col>
            </Row>

            <Row className="g-3">
                <Col xs={12} className="py-3">
                    <h3 className="Website-title">Our Vision</h3>
                    <hr />
                </Col>

                <Col xl={12} lg={12} sm={12}>
                    <label className="form-label">Our Vision Title</label>
                    <FormInput
                        placeholder="Banner Title"
                        // value={formData.category}
                        // onChange={(e) => handleChange("category", e.target.value)}
                    />
                </Col>

                <Col xs={12}>
                    <label className="form-label">Our Vision Description</label>
                    <FormInput
                        placeholder="Description"
                        type="textarea"
                        // value={formData.description}
                        // onChange={(e) => handleChange("description", e.target.value)}
                    />
                </Col>
            </Row>

            <Row className="g-3">
                <Col xs={12} className="py-3">
                    <h3 className="Website-title">Contact Us Information</h3>
                    <hr />
                </Col>

                <Col xl={6} lg={6} sm={12}>
                    <label className="form-label">Head Office</label>
                    <FormInput
                        placeholder="Head Office"
                        // value={formData.category}
                        // onChange={(e) => handleChange("category", e.target.value)}
                    />
                </Col>

                <Col xl={6} lg={6} sm={12}>
                    <label className="form-label">Phone</label>
                    <FormInput
                        placeholder="Head Office"
                        // value={formData.category}
                        // onChange={(e) => handleChange("category", e.target.value)}
                    />
                </Col>

                <Col xl={6} lg={6} sm={12}>
                    <label className="form-label">Email</label>
                    <FormInput
                        placeholder="Head Office"
                        // value={formData.category}
                        // onChange={(e) => handleChange("category", e.target.value)}
                    />
                </Col>

                <Col xl={6} lg={6} sm={12}>
                    <label className="form-label">Business Hours</label>
                    <FormInput
                        placeholder="Head Office"
                        // value={formData.category}
                        // onChange={(e) => handleChange("category", e.target.value)}
                    />
                </Col>
            </Row>
        </>
    )
}
export default Home;